import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Plane = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="93" viewBox="0 0 99 93" width="99" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path className={strokeStyle} d="M45.54 2 22.72 48.48v.01L2 90.7 14.21 7.35z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M96.68 11.63 71.55 32.62 2 90.7l51.32-67.77 12.95-17.1z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m45.54 2 7.78 20.93-30.6 25.55z" fill={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M71.55 32.62 37.02 71.55 2 90.7z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m71.55 32.62 4.68 17.49-39.21 21.44z" fill={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M53.32 22.93 2 90.7l20.72-42.21v-.01z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
    </svg>
  );
};
